/**
 * @file apify
 * @author fengpan
 */

/**
 * 使api url function 化
 *
 * e.g
 *
 *  const [
    {
        key: 'test',
        path: '/mock/9286/api/v1/vip/homepage',
        origin: "MOCK_HOST"
    }]
 *
 *  api = apify(API_CONFIG);
 *
 *  api.postCode({
 *                  method: 'get',
 *                  data:{
 *                      a:123
 *                  }
 *              })
 *      .then()
 *      .fail();
 * 
 */

import _ from 'lodash';
import request from './request';
import { AxiosRequestConfig } from 'axios';

export default function(apis: any ) {
    let res: any = {};
    apis.forEach((item: { key: string; path: string; origin: string }) => {
        let { key, path, origin } = item;
        let host: string = import.meta.env[origin] as string || '';
        res[key] = (options: AxiosRequestConfig) => {
            let param = _.assignIn({}, options);

            return request(host, path, param).catch(err => {
                console.log(err);
            });
        };
    });

    return res || {};
}
